class SectionQuiz extends HTMLElement {
  constructor() {
    super();
    this.steps = [];
    this.progressBar = null;
    this.totalSteps = 0;
    this.currentStep = 0;
  }

  connectedCallback() {
    this.initElements();
    this.setupEventListeners();
    this.showStep(0);
    this.initPhoneInput();
  }

  initElements() {
    this.steps = Array.from(this.querySelectorAll('.mpact-quiz__step-item'));
    this.progressBar = this.querySelector('.mpact-quiz__step-progress');
    this.totalSteps = this.steps.length;
    this.currentStep = 0;
  }

  setupEventListeners() {
    // Next Step buttons
    this.querySelectorAll('.next-step').forEach(btn => {
      btn.addEventListener('click', () => this.handleNextStep());
    });
    this.querySelectorAll('.prev-step').forEach(btn => {
      btn.addEventListener('click', () => this.handlePrevStep());
    });

    // Enter key event
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
       if (this.currentStep < this.totalSteps - 1) {
          e.preventDefault();
          this.handleNextStep();
        }
      }
    });

    // Checkbox logic
    this.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', () => this.handleCheckboxChange(checkbox));
    });

    // Textarea auto-resize and error hide
    this.querySelectorAll('.mpact-quiz__step-container .mpact-quiz__option-input').forEach(textarea => {
      this.setupTextareaEvents(textarea);
    });

    // Sync visible and hidden email fields
    const visibleEmailField = this.querySelector('#VisibleEmailField');
    if (visibleEmailField) {
      visibleEmailField.addEventListener('input', () => {
        this.querySelector('#HiddenEmailField').value = visibleEmailField.value;
      });
    }

    // Handle form submission success
    this.handleFormSubmissionSuccess();
  }

  updateProgress() {
    this.progressBar.style.width = ((this.currentStep + 1) / this.totalSteps * 100) + '%';
  }

  showStep(index) {
    this.steps.forEach((step, idx) => step.classList.toggle('hidden', idx !== index));
    if (index === this.totalSteps - 1) {
      this.querySelector('.mpact-quiz__btn-submit').classList.remove('hidden');
    }
    this.updateProgress();
  }

  
  handleNextStep() {
    const container = this.steps[this.currentStep];
    let valid = false;

    if (container.querySelector('input[type="hidden"]')) {
      const hiddenInput = container.querySelector('input[type="hidden"]');
      if (hiddenInput.value.trim() !== "") valid = true;
    } else if (container.querySelector('textarea')) {
      const textarea = container.querySelector('textarea');
      if (textarea.value.trim() !== "") valid = true;
    } else if (container.querySelector('.mpact-quiz__step-form')) {
      const form = container.querySelector('.mpact-quiz__step-form');
      const formInputs = form.querySelectorAll('input[required]');
      valid = true;

      formInputs.forEach(input => {
        const value = input.value.trim();
        if (
          value === "" ||
          (input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) ||
          (input.type === 'tel' && !/^[\d]{5,}$/.test(value))
        ) {
          valid = false;
          input.classList.add('error');
        }
      });

      // Input event
      form.addEventListener('input', (e) => {
        if (e.target.matches('input[required]')) {
          this.clearErrorOnInput(e.target);
        }
      });

      // Blur event
      form.addEventListener('focusout', (e) => {
        if (e.target.matches('input[required]')) {
          const input = e.target;
          const value = input.value.trim();
          if (
            value === "" ||
            (input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) ||
            (input.type === 'tel' && !/^[\d]{5,}$/.test(value))
          ) {
            input.classList.add('error');
            valid = false;
          }
        }
      });
    } else {
      const inputs = container.querySelectorAll('input[required]');
      inputs.forEach(input => {
        if (input.value.trim() !== "") valid = true;
      });
    }

    if (valid) {
      container.querySelector('.mpact-quiz__error-message').classList.add('hidden');
      this.currentStep++;
      this.showStep(this.currentStep);
    } else {
      container.querySelector('.mpact-quiz__error-message').classList.remove('hidden');
    }
  }
  handlePrevStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.showStep(this.currentStep);
    }
  }

  clearErrorOnInput(input) {
    input.classList.remove('error');
    const errorMsg = input.nextElementSibling;
    if (errorMsg?.classList.contains('error-message')) {
      errorMsg.style.display = 'none';
    }
  }

  handleCheckboxChange(checkbox) {
    checkbox.closest('.mpact-quiz__step-item').querySelector('.mpact-quiz__error-message').classList.add('hidden');
    const stepIndex = checkbox.dataset.stepIndex;
    const selectedValues = [];
    
    this.querySelectorAll(`.step-${stepIndex}-option:checked`).forEach(checkedBox => {
      selectedValues.push(checkedBox.value);
    });

    const hiddenField = this.querySelector(`#step_${stepIndex}_selected_values`);
    if (!hiddenField) {
      console.error('Hidden field not found for step:', stepIndex);
      return;
    }

    hiddenField.value = selectedValues.join(', ');
    if (checkbox.checked) {
      checkbox.parentNode.classList.add('active');
    } else {
      checkbox.parentNode.classList.remove('active');
    }
  }

  setupTextareaEvents(textarea) {
    textarea.addEventListener('input', () => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
      textarea.closest('.mpact-quiz__step-item').querySelector('.mpact-quiz__error-message').classList.add('hidden');
    });

    textarea.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
      }
    });

    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  initPhoneInput() {
    const phoneInput = this.querySelector("#stepFormPhone");
    if (phoneInput) {
      window.intlTelInput(phoneInput, {
        preferredCountries: ['es'],
        separateDialCode: true,
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
      });
    }
  }

  handleFormSubmissionSuccess() {
    const urlParams = new URLSearchParams(window.location.search);
    const hash = window.location.hash;
    const formContainer = this.querySelector('#ContactFormQuiz');
    
    if (urlParams.get('contact_posted') === 'true' && hash === '#ContactFormQuiz') {
      if (formContainer) {
        formContainer.classList.add('hidden');
        this.querySelector('.mpact-quiz__contact-success').classList.remove('hidden');
        const cleanUrl = window.location.pathname + window.location.search.replace(/(\?|&)contact_posted=true/, '') + window.location.hash.replace('#ContactFormQuiz', '');
        history.replaceState(null, '', cleanUrl);
      }
    }
  }
}

customElements.define('section-quiz', SectionQuiz);